// JsproductosRD — comportamiento compartido de las secciones mt-*
document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContadores();
  initGaleriaProducto();
});

function initReveals() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.dataset.mtDelay || 0;
          setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var contadores = document.querySelectorAll('[data-mt-contador]');
  if (!contadores.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    contadores.forEach(function (el) { el.textContent = el.dataset.mtContador; });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var final = parseFloat(el.dataset.mtContador);
        if (isNaN(final)) return;
        var duracion = 1200;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var valor = Math.floor(progreso * final);
          el.textContent = valor + (el.dataset.mtSufijo || '');
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = final + (el.dataset.mtSufijo || '');
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );

  contadores.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !miniaturas.length) return;

  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var nuevaSrc = mini.dataset.mtMiniatura;
      var nuevoAlt = mini.getAttribute('data-mt-alt') || '';
      principal.src = nuevaSrc;
      principal.alt = nuevoAlt;
      miniaturas.forEach(function (m) { m.classList.remove('mt-miniatura-activa'); });
      mini.classList.add('mt-miniatura-activa');
    });
  });
}
